import { userTypeRedirect } from "components/login-page/functions";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useEffect } from "react";
import { useRouter } from "routes/router-control/use-router";

export function IndexPage() {
  const { user } = useApplicationContext();
  const router = useRouter();

  useEffect(() => {
    router.push(userTypeRedirect(user));
  }, []);

  return <></>;
}
